<template>
  <main>
    <Hero :program="program" />
    <Trail />
    <SubprogramList :subprograms="program.subprograms" />
    <!--
      <OurTeam />
    -->
    <ProjectList />
    <Publications :program="program" />
  </main>
</template>

<script>
import programs from "@/data.js";
import Hero from "@/components/home/Hero";
import Trail from "@/components/common/Trail";
import SubprogramList from "@/components/home/SubprogramList";
import Publications from "@/components/home/Publications";
import ProjectList from "@/components/home/ProjectList.vue";
//import OurTeam from "@/components/home/OurTeam";

export default {
  components: {
    Hero,
    Trail,
    SubprogramList,
    ProjectList,
    Publications
    //OurTeam
  },
  setup() {
    const program = programs[process.env.VUE_APP_PREFIX];
    return {
      program
    };
  }
};
</script>
<style lang="scss" scoped>
@use "@/assets/styles/settings/_variables.scss";
.trail {
  border-top: 1px solid variables.$border-header-color;
  margin-bottom: 0;
}
</style>
